// extracted by mini-css-extract-plugin
export default {"documentsGrid":"rt6v3h2Q9xB2ZjFbCdZg"};